import axiosAuth from "@/axios-auth";

// Nenhum módulo Vuex deste projeto é namespaced: tudo aqui é prefixado com "notificacoes"
// para não colidir com os outros 44 módulos.
const state = {
  notificacoes: [],
  notificacoesContador: 0,
  notificacoesLoading: false,
  notificacoesLoadingMais: false,
  notificacoesFiltroStatus: "todas",
  notificacoesPolling: null,
  notificacoesVisibilityHandler: null,
  notificacoesTipos: [],
  // preferências do usuário aberto na modal: { notificacao_tipo_id: bool }
  notificacoesPreferencias: {},
  // vale para os tipos marcados, não é um tipo a mais; nasce desligado
  notificacoesEmailAtivo: false,
  notificacaoUsuarioAlvo: null,
  notificacoesPreferenciasLoading: false,
  notificacoesPreferenciasSalvando: false,
  OpenDialogNotificacoesUsuario: false,
  pagingNotificacoes: {
    page: 1,
    current: 0,
    count: 0,
    perPage: 20,
    pageCount: 1,
    nextPage: false,
    prevPage: false,
  },
  pushSuportado: false,
  pushConfigurado: false,
  pushAtivo: false,
  pushProcessando: false,
};

/**
 * A chave VAPID trafega em base64url e o navegador exige um Uint8Array em applicationServerKey.
 *
 * @param {string} base64 Chave pública VAPID.
 * @returns {Uint8Array}
 */
function base64ParaUint8Array(base64) {
  const preenchimento = "=".repeat((4 - (base64.length % 4)) % 4);
  const normalizada = (base64 + preenchimento).replace(/-/g, "+").replace(/_/g, "/");
  const bruto = window.atob(normalizada);
  const saida = new Uint8Array(bruto.length);

  for (let i = 0; i < bruto.length; ++i) {
    saida[i] = bruto.charCodeAt(i);
  }

  return saida;
}

/**
 * Push exige service worker, Push API e permissão de notificação. No iOS só existe quando o
 * site foi adicionado à tela de início.
 *
 * @returns {boolean}
 */
function navegadorSuportaPush() {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

const mutations = {
  SET_NOTIFICACOES(state, v) {
    state.notificacoes = v;
  },
  APPEND_NOTIFICACOES(state, v) {
    state.notificacoes = state.notificacoes.concat(v);
  },
  SET_NOTIFICACOES_CONTADOR(state, v) {
    state.notificacoesContador = v;
  },
  SET_NOTIFICACOES_LOADING(state, v) {
    state.notificacoesLoading = v;
  },
  SET_NOTIFICACOES_LOADING_MAIS(state, v) {
    state.notificacoesLoadingMais = v;
  },
  SET_NOTIFICACOES_FILTRO_STATUS(state, v) {
    state.notificacoesFiltroStatus = v;
  },
  SET_NOTIFICACOES_POLLING(state, v) {
    state.notificacoesPolling = v;
  },
  SET_NOTIFICACOES_VISIBILITY_HANDLER(state, v) {
    state.notificacoesVisibilityHandler = v;
  },
  SET_PAGING_NOTIFICACOES(state, v) {
    state.pagingNotificacoes = Object.assign({}, state.pagingNotificacoes, v);
  },
  // atualiza uma notificação já carregada sem refazer a listagem inteira
  UPDATE_NOTIFICACAO_LIDA(state, { id, lido }) {
    const item = state.notificacoes.find((n) => n.id === id);
    if (item) {
      item.lido = lido;
    }
  },
  MARCAR_TODAS_NOTIFICACOES_LIDAS(state) {
    state.notificacoes.forEach((n) => {
      n.lido = true;
    });
  },
  REMOVER_NOTIFICACAO(state, id) {
    state.notificacoes = state.notificacoes.filter((n) => n.id !== id);
  },
  SET_NOTIFICACOES_TIPOS(state, v) {
    state.notificacoesTipos = v;
  },
  SET_NOTIFICACAO_USUARIO_ALVO(state, v) {
    state.notificacaoUsuarioAlvo = v;
  },
  SET_NOTIFICACOES_PREFERENCIAS(state, v) {
    state.notificacoesPreferencias = v;
  },
  SET_NOTIFICACOES_EMAIL_ATIVO(state, v) {
    state.notificacoesEmailAtivo = v === true;
  },
  OpenDialogNotificacoesUsuario(state, v) {
    state.OpenDialogNotificacoesUsuario = v;
  },
  SET_NOTIFICACOES_PREFERENCIAS_LOADING(state, v) {
    state.notificacoesPreferenciasLoading = v;
  },
  SET_NOTIFICACOES_PREFERENCIAS_SALVANDO(state, v) {
    state.notificacoesPreferenciasSalvando = v;
  },
  SET_PUSH_SUPORTADO(state, v) {
    state.pushSuportado = v;
  },
  SET_PUSH_CONFIGURADO(state, v) {
    state.pushConfigurado = v;
  },
  SET_PUSH_ATIVO(state, v) {
    state.pushAtivo = v;
  },
  SET_PUSH_PROCESSANDO(state, v) {
    state.pushProcessando = v;
  },
  // reatribui o objeto inteiro: chave nova em objeto reativo não é detectada no Vue 2
  TOGGLE_NOTIFICACAO_PREFERENCIA(state, { tipoId, ativo }) {
    state.notificacoesPreferencias = Object.assign({}, state.notificacoesPreferencias, {
      [tipoId]: ativo,
    });
  },
};

const actions = {
  async fetchNotificacoes({ commit, state }, opcoes) {
    const append = opcoes && opcoes.append === true;
    const page = append ? state.pagingNotificacoes.page + 1 : 1;

    commit(append ? "SET_NOTIFICACOES_LOADING_MAIS" : "SET_NOTIFICACOES_LOADING", true);

    const res = await axiosAuth.get("/notificacoes", {
      params: {
        page: page,
        status: state.notificacoesFiltroStatus,
      },
    });

    commit(append ? "SET_NOTIFICACOES_LOADING_MAIS" : "SET_NOTIFICACOES_LOADING", false);

    if (res.error) {
      if (!append) {
        commit("SET_NOTIFICACOES", []);
      }
      return;
    }

    const lista = Array.isArray(res.data.data) ? res.data.data : [];
    commit(append ? "APPEND_NOTIFICACOES" : "SET_NOTIFICACOES", lista);

    if (res.data.paging) {
      commit("SET_PAGING_NOTIFICACOES", res.data.paging);
    }
  },

  async fetchNotificacoesContador({ commit }) {
    const res = await axiosAuth.get("/notificacoes/contador");
    if (res.error) return;

    const dados = res.data.data || {};
    commit("SET_NOTIFICACOES_CONTADOR", dados.nao_lidas || 0);
  },

  /**
   * Polling do badge. Não busca com a aba em background — o sino não precisa estar
   * atualizado enquanto ninguém olha, e sem isso são milhares de requisições ociosas por dia.
   * Ao voltar para a aba, busca na hora em vez de esperar o próximo ciclo.
   */
  iniciarPollingNotificacoes({ commit, dispatch, state }) {
    dispatch("pararPollingNotificacoes");
    dispatch("fetchNotificacoesContador");

    const intervalo = setInterval(() => {
      if (document.hidden) return;
      dispatch("fetchNotificacoesContador");
    }, 60000);

    const handler = () => {
      if (!document.hidden) {
        dispatch("fetchNotificacoesContador");
      }
    };
    document.addEventListener("visibilitychange", handler);

    commit("SET_NOTIFICACOES_POLLING", intervalo);
    commit("SET_NOTIFICACOES_VISIBILITY_HANDLER", handler);
  },

  pararPollingNotificacoes({ commit, state }) {
    if (state.notificacoesPolling) {
      clearInterval(state.notificacoesPolling);
      commit("SET_NOTIFICACOES_POLLING", null);
    }
    if (state.notificacoesVisibilityHandler) {
      document.removeEventListener("visibilitychange", state.notificacoesVisibilityHandler);
      commit("SET_NOTIFICACOES_VISIBILITY_HANDLER", null);
    }
  },

  /**
   * Conteúdo longo fica fora da listagem para não inflar o payload de cada página;
   * é buscado só quando o usuário abre o item.
   */
  async fetchNotificacaoConteudo({ commit }, id) {
    const res = await axiosAuth.get(`/notificacoes/${id}/conteudo`);
    if (res.error) return null;

    return res.data.data || null;
  },

  /**
   * Acontecimentos individuais de uma notificação agrupada. Buscados só ao abrir, porque
   * podem ser dezenas por item.
   */
  async fetchNotificacaoOcorrencias({ commit }, id) {
    const res = await axiosAuth.get(`/notificacoes/${id}/ocorrencias`);
    if (res.error) return null;

    return res.data.data || null;
  },

  async marcarNotificacaoLida({ commit, dispatch }, id) {
    const res = await axiosAuth.post(`/notificacoes/${id}/ler`);
    if (res.error) return false;

    commit("UPDATE_NOTIFICACAO_LIDA", { id, lido: true });
    dispatch("fetchNotificacoesContador");
    return true;
  },

  async marcarNotificacaoNaoLida({ commit, dispatch }, id) {
    const res = await axiosAuth.post(`/notificacoes/${id}/nao-ler`);
    if (res.error) return false;

    commit("UPDATE_NOTIFICACAO_LIDA", { id, lido: false });
    dispatch("fetchNotificacoesContador");
    return true;
  },

  async marcarTodasNotificacoesLidas({ commit, dispatch }) {
    const res = await axiosAuth.post("/notificacoes/ler-todas");
    if (res.error) return false;

    commit("MARCAR_TODAS_NOTIFICACOES_LIDAS");
    dispatch("fetchNotificacoesContador");
    return true;
  },

  async excluirNotificacao({ commit, dispatch }, id) {
    const res = await axiosAuth.delete(`/notificacoes/${id}`);
    if (res.error) return false;

    commit("REMOVER_NOTIFICACAO", id);
    dispatch("fetchNotificacoesContador");
    return true;
  },

  alterarFiltroNotificacoes({ commit, dispatch }, status) {
    commit("SET_NOTIFICACOES_FILTRO_STATUS", status);
    dispatch("fetchNotificacoes");
  },

  /**
   * Descobre se o push está disponível: navegador com suporte, servidor com chaves VAPID e
   * se este dispositivo já tem inscrição.
   */
  async verificarStatusPush({ commit }) {
    const suportado = navegadorSuportaPush();
    commit("SET_PUSH_SUPORTADO", suportado);

    if (!suportado) return;

    const res = await axiosAuth.get("/notificacoes/push/chave-publica");
    if (res.error) return;

    const dados = res.data.data || {};
    commit("SET_PUSH_CONFIGURADO", dados.configurado === true);

    if (!dados.configurado) return;

    try {
      const registro = await navigator.serviceWorker.getRegistration();
      const inscricao = registro ? await registro.pushManager.getSubscription() : null;

      commit("SET_PUSH_ATIVO", !!inscricao && Notification.permission === "granted");
    } catch (e) {
      commit("SET_PUSH_ATIVO", false);
    }
  },

  /**
   * Pede a permissão e registra a inscrição no servidor.
   *
   * Só funciona sobre HTTPS (ou localhost) e com o service worker registrado — em `npm run
   * dev` o SW não é registrado, então isto só se comporta como em produção num build.
   *
   * @returns {Promise<{ok: boolean, motivo: string}>}
   */
  async inscreverPush({ commit, state }) {
    if (!state.pushSuportado) {
      return { ok: false, motivo: "Este navegador não suporta notificações push." };
    }

    commit("SET_PUSH_PROCESSANDO", true);

    try {
      const permissao = await Notification.requestPermission();

      if (permissao !== "granted") {
        commit("SET_PUSH_PROCESSANDO", false);
        return {
          ok: false,
          motivo: "Permissão de notificações negada no navegador.",
        };
      }

      const chaveRes = await axiosAuth.get("/notificacoes/push/chave-publica");

      if (chaveRes.error || !(chaveRes.data.data || {}).chave_publica) {
        commit("SET_PUSH_PROCESSANDO", false);
        return { ok: false, motivo: "O servidor não está configurado para push." };
      }

      const registro = await navigator.serviceWorker.ready;

      const inscricao = await registro.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: base64ParaUint8Array(chaveRes.data.data.chave_publica),
      });

      const res = await axiosAuth.post("/notificacoes/push/inscrever", {
        inscricao: JSON.parse(JSON.stringify(inscricao)),
      });

      commit("SET_PUSH_PROCESSANDO", false);

      if (res.error) {
        return { ok: false, motivo: "Não foi possível registrar o dispositivo." };
      }

      commit("SET_PUSH_ATIVO", true);
      return { ok: true, motivo: "" };
    } catch (e) {
      commit("SET_PUSH_PROCESSANDO", false);
      return { ok: false, motivo: "Falha ao ativar as notificações push." };
    }
  },

  /**
   * Cancela no navegador e remove do servidor. A ordem importa: se o servidor cair no meio,
   * é melhor sobrar registro no banco (que morre no primeiro 410) do que o navegador seguir
   * inscrito sem ninguém para enviar.
   */
  async desinscreverPush({ commit }) {
    commit("SET_PUSH_PROCESSANDO", true);

    try {
      const registro = await navigator.serviceWorker.getRegistration();
      const inscricao = registro ? await registro.pushManager.getSubscription() : null;

      if (inscricao) {
        const endpoint = inscricao.endpoint;
        await inscricao.unsubscribe();
        await axiosAuth.post("/notificacoes/push/desinscrever", { endpoint });
      }

      commit("SET_PUSH_ATIVO", false);
      commit("SET_PUSH_PROCESSANDO", false);
      return { ok: true, motivo: "" };
    } catch (e) {
      commit("SET_PUSH_PROCESSANDO", false);
      return { ok: false, motivo: "Falha ao desativar as notificações push." };
    }
  },

  /**
   * Abre a modal de notificações de um usuário. Sem userId, é o próprio.
   */
  async abrirNotificacoesUsuario({ commit, dispatch }, usuario) {
    commit("SET_NOTIFICACAO_USUARIO_ALVO", usuario || null);
    commit("OpenDialogNotificacoesUsuario", true);

    await dispatch("fetchNotificacoesPreferencias", usuario ? usuario.id : null);
  },

  async fetchNotificacoesPreferencias({ commit }, userId) {
    commit("SET_NOTIFICACOES_PREFERENCIAS_LOADING", true);

    const res = await axiosAuth.get("/notificacoes/preferencias", {
      params: userId ? { user_id: userId } : {},
    });

    commit("SET_NOTIFICACOES_PREFERENCIAS_LOADING", false);

    if (res.error) return false;

    const dados = res.data.data || {};
    commit("SET_NOTIFICACOES_TIPOS", dados.tipos || []);
    commit("SET_NOTIFICACOES_PREFERENCIAS", dados.preferencias || {});
    commit("SET_NOTIFICACOES_EMAIL_ATIVO", dados.email_ativo);
    commit("SET_NOTIFICACAO_USUARIO_ALVO", dados.usuario || null);

    return true;
  },

  async salvarNotificacoesPreferencias({ commit, state }) {
    // tipo obrigatório não é enviado: o servidor o ignoraria de qualquer forma
    const preferencias = state.notificacoesTipos
      .filter((tipo) => tipo.permite_desativar)
      .map((tipo) => ({
        notificacao_tipo_id: tipo.id,
        ativo: state.notificacoesPreferencias[tipo.id] === true,
      }));

    const payload = {
      preferencias,
      email_ativo: state.notificacoesEmailAtivo === true,
    };

    if (state.notificacaoUsuarioAlvo) {
      payload.user_id = state.notificacaoUsuarioAlvo.id;
    }

    commit("SET_NOTIFICACOES_PREFERENCIAS_SALVANDO", true);

    const res = await axiosAuth.post("/notificacoes/preferencias", payload);

    commit("SET_NOTIFICACOES_PREFERENCIAS_SALVANDO", false);

    if (res.error) return false;

    commit("OpenDialogNotificacoesUsuario", false);
    return true;
  },
};

const getters = {
  notificacoes: (state) => state.notificacoes,
  notificacoesContador: (state) => state.notificacoesContador,
  notificacoesLoading: (state) => state.notificacoesLoading,
  notificacoesLoadingMais: (state) => state.notificacoesLoadingMais,
  notificacoesFiltroStatus: (state) => state.notificacoesFiltroStatus,
  pagingNotificacoes: (state) => state.pagingNotificacoes,
  temMaisNotificacoes: (state) =>
    state.pagingNotificacoes.page < state.pagingNotificacoes.pageCount,
  notificacoesTipos: (state) => state.notificacoesTipos,
  notificacaoUsuarioAlvo: (state) => state.notificacaoUsuarioAlvo,
  notificacoesPreferencias: (state) => state.notificacoesPreferencias,
  notificacoesEmailAtivo: (state) => state.notificacoesEmailAtivo,
  OpenDialogNotificacoesUsuario: (state) => state.OpenDialogNotificacoesUsuario,
  // define se o botão de configurar aparece nas linhas dos OUTROS usuários; configurar as
  // próprias notificações não depende de permissão
  podeConfigurarNotificacoesDeOutros: (state, getters, rootState) => {
    const acesso =
      rootState.profile && rootState.profile.dataUser
        ? rootState.profile.dataUser.acesso
        : null;

    return Array.isArray(acesso) && acesso.includes("Notificacoes.preferencias");
  },
  notificacoesPreferenciasLoading: (state) => state.notificacoesPreferenciasLoading,
  notificacoesPreferenciasSalvando: (state) => state.notificacoesPreferenciasSalvando,
  pushSuportado: (state) => state.pushSuportado,
  pushConfigurado: (state) => state.pushConfigurado,
  pushAtivo: (state) => state.pushAtivo,
  pushProcessando: (state) => state.pushProcessando,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
